import { GuardFactory } from './app.guard.factory';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { QueryParamatersService } from '../core/services/queryParameters.service';
import { AuthguardOption } from '../enum/authguardOption';

@Injectable()
export class MainGuard {
  constructor(
    private guardFactory: GuardFactory,
    private queryParamatersService: QueryParamatersService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isVersionRoute = state.url === '/version';

    if (isVersionRoute) {
      // Skip authentication for /version route
      return Promise.resolve(true);
    }

    const authguardOption: string = this.queryParamatersService.validMacUser ? AuthguardOption.KEYCLOAK_OFF : AuthguardOption.KEYCLOAK_ON;

    return Promise.resolve(this.guardFactory.getInstance(authguardOption).canActivate(route, state) as Promise<boolean>);
  }
}
